import React, { useCallback, useMemo, useState } from 'react'
import VendorPayments from '../../components/payments/Vendor'
import Details from '../../components/payments/Vendor/Details'
import Modal from '../../components/payments/Vendor/Modal'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'

const MOCK_DATA = [
	{
		id: 1,
		payment_id: 'P-1001',
		image: 'https://www.kathleenwynne.ca/wp-content/uploads/2023/04/2.jpg',
		party: 'Devon & Jenny',
		amount: 25000,
		due_date: '2025-11-10',
		status: 'Completed',
		invoice: 'INV-2001',
	},
	{
		id: 2,
		payment_id: 'P-1002',
		image: 'https://www.kathleenwynne.ca/wp-content/uploads/2023/04/2.jpg',
		party: 'Liam & Emma',
		amount: 32000,
		due_date: '2025-11-15',
		status: 'Pending',
		invoice: 'INV-2002',
	},
	{
		id: 3,
		payment_id: 'P-1003',
		image: 'https://www.kathleenwynne.ca/wp-content/uploads/2023/04/2.jpg',
		party: 'Olivia & Noah',
		amount: 18000,
		due_date: '2025-11-18',
		status: 'Charged',
		invoice: 'INV-2003',
	},
	{
		id: 4,
		payment_id: 'P-1004',
		image: 'https://www.kathleenwynne.ca/wp-content/uploads/2023/04/2.jpg',
		party: 'Sophia & Mason',
		amount: 27000,
		due_date: '2025-11-22',
		status: 'Completed',
		invoice: 'INV-2004',
	},
	{
		id: 5,
		payment_id: 'P-1005',
		image: 'https://www.kathleenwynne.ca/wp-content/uploads/2023/04/2.jpg',
		party: 'Ava & Ethan',
		amount: 29000,
		due_date: '2025-11-25',
		status: 'Pending',
		invoice: 'INV-2005',
	},
	{
		id: 6,
		payment_id: 'P-1006',
		image: 'https://www.kathleenwynne.ca/wp-content/uploads/2023/04/2.jpg',
		party: 'Isabella & Lucas',
		amount: 35000,
		due_date: '2025-11-30',
		status: 'Completed',
		invoice: 'INV-2006',
	},
	{
		id: 7,
		payment_id: 'P-1007',
		image: 'https://www.kathleenwynne.ca/wp-content/uploads/2023/04/2.jpg',
		party: 'Mia & James',
		amount: 22000,
		due_date: '2025-12-02',
		status: 'Charged',
		invoice: 'INV-2007',
	},
	{
		id: 8,
		payment_id: 'P-1008',
		image: 'https://www.kathleenwynne.ca/wp-content/uploads/2023/04/2.jpg',
		party: 'Charlotte & Benjamin',
		amount: 40000,
		due_date: '2025-12-05',
		status: 'Pending',
		invoice: 'INV-2008',
	},
	{
		id: 9,
		payment_id: 'P-1009',
		image: 'https://www.kathleenwynne.ca/wp-content/uploads/2023/04/2.jpg',
		party: 'Amelia & Henry',
		amount: 26000,
		due_date: '2025-12-08',
		status: 'Completed',
		invoice: 'INV-2009',
	},
	{
		id: 10,
		payment_id: 'P-1010',
		image: 'https://www.kathleenwynne.ca/wp-content/uploads/2023/04/2.jpg',
		party: 'Harper & William',
		amount: 31000,
		due_date: '2025-12-12',
		status: 'Pending',
		invoice: 'INV-2010',
	},
]

export default function PaymentsPage() {
	const [activeModal, setActiveModal] = useState('')
	const [details, setDetails] = useState(null)

	const formattedData = useMemo(
		() =>
			MOCK_DATA.map((d) => ({
				...d,
				viewDetails: () => onViewDetail(d.id),
			})),
		[MOCK_DATA]
	)

	const openCreateModal = () => setActiveModal('create')
	const closeAllModals = () => setActiveModal('')

	const handleSubmit = () => {
		//
	}

	const onViewDetail = useCallback(
		(selectedId) => {
			const data = formattedData.find(({ id }) => id === selectedId)
			setDetails(data ?? null)
		},
		[formattedData]
	)

	if (details)
		return <Details data={details} onBack={() => setDetails(null)} />

	return (
		<>
			<VendorPayments
				data={formattedData}
				openCreateModal={openCreateModal}
			/>

			<Modal
				activeModal={activeModal}
				closeAllModals={closeAllModals}
				handleSubmit={handleSubmit}
				page="planner-payments"
				
			/>
		</>
	)
}
